import moment from "moment";
import React, { useEffect, useState } from "react";
import Button1 from "../../form/Button1";
import TextInput from "../../form/TextInput";
import { CircularProgress, MenuItem } from "@mui/material";
import getAdminTeamMembers from "../../../controllers/settings/adminTeam/getTeamMembers";
import { ComparePAX } from "./ComparePAX";
import { PriceBreakdown } from "./PriceBreakdown";
import { CompareFlightChange } from "./CompareFlightChange";
import { enqueueSnackbar } from "notistack";
import setChangeFee from "../../../controllers/booking/postTicketing/change/setChangeFee";

export default function EditTicket({ data, reload }) {
  const [handleOption, setHandleOption] = useState("direct");
  const [details, setDetails] = useState("");
  const [staffs, setStaffs] = useState([]);
  const [loadings, setLoadings] = useState({
    fetchStaff: false,
    submit: false,
  });
  const [feeData, setFeeData] = useState({
    penality: data?.fee || 0,
    ticketDifference: data?.ticketDifference || 0,
  });

  useEffect(() => {
    if (data) loadStaff();
  }, [data]);

  async function loadStaff() {
    setLoadings({ ...(loadings || {}), fetchStaff: true });
    const res = await getAdminTeamMembers();
    setLoadings({ ...(loadings || {}), fetchStaff: false });
    if (res.return) {
      setStaffs(res?.data?.data || []);
    }
  }

  async function handleSubmit() {
    const reqBody = {
      changeOrderId: data?._id,
      changePrice: Number(feeData?.penality || 0),
      ticketDifference: Number(feeData?.ticketDifference || 0),
      remark: details,
    };
    setLoadings({ ...loadings, submit: true });
    const res = await setChangeFee(reqBody);
    setLoadings({ ...loadings, submit: false });

    if (res.return) {
      enqueueSnackbar("Quote Complete.", { variant: "success" });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  function handlePriceChange(data) {
    setFeeData(data);
  }

  //   console.log({ data, type: "Edit ticket" });
  let title = "PAX Change";
  if (data?.newSegment?.length) title = "Date Change";
  return (
    <div className="flex flex-col gap-4">
      <div>
        <div className="flex gap-1">
          <p>Ticket Number: </p>
          <span>{data?.orderId}</span>
        </div>
        <div className="flex gap-1">
          <p>Re-issue Request Time: </p>
          <span>
            {data?.updatedAt
              ? moment(data?.updatedAt)?.format("YYYY-MM-DD, HH:mm")
              : ""}
          </span>
        </div>
      </div>
      <div className="flex justify-end">
        <div>
          <Button1 variant="text">Check fare rules</Button1>
        </div>
      </div>
      {title === "PAX Change" ? (
        <ComparePAX
          data={{
            previous: data?.flightBooking
              ?.at(0)
              ?.travelers?.find(
                (obj) => obj?.id === data?.passengerInfo?.at(0)?.id
              ),
            newData: data?.passengerInfo?.at(0),
          }}
        />
      ) : (
        <CompareFlightChange
          data={{ flight: data, oldOrder: data, query: data }}
        />
      )}

      <PriceBreakdown data={data} callback={handlePriceChange} />

      <TextInput
        label="Remarks"
        multiline
        rows={4}
        value={details}
        onChange={(ev) => setDetails(ev.target.value)}
      />

      <div className="flex justify-end">
        <div>
          <Button1 onClick={handleSubmit}>Confirm</Button1>
        </div>
      </div>
    </div>
  );
}
